/**
 * Mirrors Xpress.DB.Enums.XpressRiderActivityStatus.
 * Keep in sync with Xpress.Api.Net/Xpress.DB/Enums/XpressRiderActivityStatus.cs
 */
export enum XpressRiderActivityStatusEnum {
	None = 0,
	Offline = 1,
	Online = 2,
	OnActiveOrder = 3,
	Idle = 4,
	Moving = 5,
	OTW = 6,
	Pickup = 7,
	/** Taxi only — mirrors backend XpressRiderActivityStatus.OnBreak */
	OnBreak = 8,
	/** Taxi only — mirrors backend XpressRiderActivityStatus.LunchBreak */
	LunchBreak = 9
}
